/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DailySummaryReportModelSearchResultModel } from '../../models/daily-summary-report-model-search-result-model';
import { OrgAdminSearchRequestModel } from '../../models/org-admin-search-request-model';

export interface OrgAdminDailySummaryReportPost$Params {
      body?: OrgAdminSearchRequestModel
}

export function orgAdminDailySummaryReportPost(http: HttpClient, rootUrl: string, params?: OrgAdminDailySummaryReportPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<DailySummaryReportModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, orgAdminDailySummaryReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<DailySummaryReportModelSearchResultModel>;
    })
  );
}

orgAdminDailySummaryReportPost.PATH = '/OrgAdmin/DailySummaryReport';
